import { useCallback } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { Number3 } from '@fabric-web/3d-viewer';
import { FindViewpointsToolState } from '@/types';
import * as moduleState from '../state';

export const useFindViewpointsTool = () => {
  const [findViewpointsToolState, setFindViewpointsToolState] = useAtom(
    moduleState.findViewpointsToolState
  );
  const setCurrentVoxelPoint = useSetAtom(moduleState.currentVoxelPoint);
  const setCurrentVoxel = useSetAtom(moduleState.currentVoxel);
  const setFoundViewpoints = useSetAtom(moduleState.foundViewpoints);
  const setShowPointMarker = useSetAtom(moduleState.showPointMarker);

  const isFindViewpointsToolActive = findViewpointsToolState !== FindViewpointsToolState.INACTIVE;

  const activateFindViewpointsTool = useCallback(() => {
    setFindViewpointsToolState(FindViewpointsToolState.WAITING_FOR_POINT);
  }, [setFindViewpointsToolState]);

  const deactivateFindViewpointsTool = useCallback(() => {
    setCurrentVoxelPoint(undefined);
    setCurrentVoxel(undefined);
    setFoundViewpoints([]);
    setFindViewpointsToolState(FindViewpointsToolState.INACTIVE);
  }, [setFindViewpointsToolState, setFoundViewpoints, setCurrentVoxelPoint, setCurrentVoxel]);

  const clearFindViewpointsTool = useCallback(() => {
    setCurrentVoxelPoint(undefined);
    setCurrentVoxel(undefined);
    setFoundViewpoints([]);
    setFindViewpointsToolState(FindViewpointsToolState.WAITING_FOR_POINT);
  }, [setFindViewpointsToolState, setFoundViewpoints, setCurrentVoxelPoint, setCurrentVoxel]);

  const onPointSelect = useCallback(
    (position: number | number[] | undefined) => {
      if (
        findViewpointsToolState === FindViewpointsToolState.INACTIVE ||
        position === undefined ||
        !Array.isArray(position) ||
        position.length !== 3
      ) {
        return;
      }
      const point: Number3 = position as Number3;

      setCurrentVoxelPoint(point);
      setShowPointMarker(true);
    },
    [findViewpointsToolState, setCurrentVoxelPoint, setShowPointMarker]
  );

  return {
    isFindViewpointsToolActive,
    activateFindViewpointsTool,
    deactivateFindViewpointsTool,
    clearFindViewpointsTool,
    onPointSelect,
  };
};
